import { Menu } from './menu';
import { User } from './user';

export class BluePrintRole {
  name: string;
  display_name: string;
  has_menu: Array<string>;
  status: string;
}

export class Role extends BluePrintRole {
  _id: string;
  count: number;
  members: Array<User>;
  non_members: Array<User>;
  created_at: Date;
  updated_at: Date;
}

export class SwitchRole {
  token: string;
  selected_role_div: number;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/role.ts